import { NewTableDefaultDataItem } from '@common/components/new-table/new-table.types';
import { Row as RowType } from '@tanstack/react-table';
import * as React from 'react';
import cx from 'classnames';

import './row.styles.scss';

export type RowProps = {
  index: number;
  selected?: boolean;
  model: RowType<NewTableDefaultDataItem>;
  onContextMenu?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
  onClick?: (params: { item: NewTableDefaultDataItem; e: React.MouseEvent<HTMLTableRowElement> }) => void;
};

export const Row: React.FC<RowProps> = (props) => {
  const { model, onClick, selected, onContextMenu, index } = props;

  const handleClick = React.useCallback((e: React.MouseEvent<HTMLTableRowElement>) => {
    if (onClick) {
      onClick({
        item: model.original,
        e,
      });
    }
  }, [model.original, onClick]);

  return (
    <tr 
      className={cx(
        'NewTable__body__row', 
        { 
          'NewTable__body__row--even': (index + 1) % 2 === 0,
          'NewTable__body__row--selected': selected,
        }
      )} 
      onClick={onClick ? handleClick : undefined}
      onContextMenu={onContextMenu}
    >
      {model.getVisibleCells().map((cell) => {
        let content: React.ReactNode;

        if (cell.column.columnDef.cell) {
          if (typeof cell.column.columnDef.cell === 'function') {
            content = cell.column.columnDef.cell(cell.getContext())
          } else {
            content = cell.column.columnDef.cell;
          }
        } else {
          content = model.getValue(cell.column.id);
        }

        return (
          <td
            key={cell.id}
            style={{
              minWidth: cell.column.getSize(),
              width: cell.column.getSize(),
              maxWidth: cell.column.getSize(),
            }}
            title={content?.toString()}
            className="NewTable__body__row__cell"
          >
            {content}
          </td>
        );
      })}
    </tr>
  );
};